import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'image',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Updated At',
    field: 'updatedAt',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const StatList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows:
            props.stats &&
            props.stats.map((x) => ({
              ...x,
              name: x.name,
              image: (
                <img
                  src={x.image}
                  className='rounded-circle avatar-sm card-img'
                />
              ),
              createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
              updatedAt: dayjs(x.updateddAt).format('DD/MM/YYYY'),
              actions: (
                <Button color='info' onClick={() => props.editStat(x)}>
                  Edit
                </Button>
              ),
            })),
        }}
      />
    </>
  );
};

export default StatList;
